import React, { useState } from "react";
import { GetMoneyValue, getThousandComma } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import { Filters, TotalCount } from "../../../../pages/Users/UserInfo";
import LineBtn from "../../../Button/LineBtn";
import ExcelDownload from "../../../DefaultStyles/ExcelDownload";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import RefundModal from "./SimplePayFail/RefundModal";

interface ISimplePayFail {
  amount: number;
  id: string;
  name: string;
  nickname: string;
  reason: string;
  time: string;
  uid: string;
}

export default function SimplePayFail() {
  const tableHead = [
    "UID_이름_닉네임",
    "적요",
    "금액",
    "결제 실패 일시",
    "환불",
  ];

  const [page, setPage] = useState(0);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [refundModal, setRefundModal] = useState({
    modal: false,
    id: "",
    user: "",
  });

  const options: OptionType[] = [
    { value: "uid", label: "UID" },
    { value: "name", label: "이름" },
    { value: "nickname", label: "닉네임" },
    { value: "phone", label: "전화번호" },
  ];

  const { response, loading, fetchData } = useApi({
    method: "get",
    url:
      `pay/1?page=${page}&size=10&isRefund=1` +
      (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``),
  });

  return (
    <>
      <Filters>
        <DropDown
          isDisabled={false}
          setDropDownValue={setDropDownValue}
          dropdownValue={dropDownValue}
          optionList={options}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          isDisabled={dropDownValue ? false : true}
          pageResetEvent={() => setPage(0)}
          inputType={
            dropDownValue?.value === "phone" || dropDownValue?.value === "uid"
              ? "number"
              : undefined
          }
        />
      </Filters>

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {response?.data?.items?.map((d: ISimplePayFail, index: number) => (
              <TableBody key={index}>
                <TableBodyItem>
                  {d?.uid}_{d?.name}_{d?.nickname}
                </TableBodyItem>

                <TableBodyItem>{d?.reason}</TableBodyItem>

                <TableBodyItem>{GetMoneyValue(d?.amount)}</TableBodyItem>

                <TableBodyItem>{d?.time}</TableBodyItem>

                <TableBodyItem>
                  <LineBtn
                    btnText="환불하기"
                    btnClickEvent={() =>
                      setRefundModal({
                        modal: true,
                        id: d?.id,
                        user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                      })
                    }
                  />
                </TableBodyItem>
              </TableBody>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        disabled={false}
        dataUrl={
          `pay/1?page=${page}&size=1000&isRefund=1` +
          (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``)
        }
        title="단건 결제 실패"
        tableHead={[
          "UID_이름_닉네임",
          "적요",
          "금액",
          "결제 실패 일시",
          "환불",
        ]}
        pushedData={(d: ISimplePayFail) => {
          return [
            `${d?.uid}_${d?.name}_${d?.nickname}`,
            `${d?.reason}`,
            `${GetMoneyValue(d?.amount)}`,
            `${d?.time}`,
          ];
        }}
      />

      {loading && <Loader />}

      {refundModal.modal && (
        <RefundModal
          closeEvent={() =>
            setRefundModal({
              id: "",
              modal: false,
              user: "",
            })
          }
          confirmEvent={() => {
            fetchData({
              method: "get",
              url:
                `pay/1?page=${page}&size=10&isRefund=1` +
                (searchValue ? `&${dropDownValue?.value}=${searchValue}` : ``),
            });
          }}
          simplePayId={refundModal.id}
          user={refundModal.user}
        />
      )}
    </>
  );
}
